var render = function render(){
  var _vm$potentialRoles;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "modalNewProspectPrompt",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": !_vm.isMobile,
      "hide-header-close": _vm.preventClosing,
      "no-close-on-backdrop": _vm.preventClosing,
      "no-close-on-esc": _vm.preventClosing
    },
    on: {
      "hide": _vm.handleClose,
      "ok": _vm.approveProspect,
      "cancel": _vm.openConfirmDeclineProspect
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.headerContainer
  }, [_c('h2', [_vm._v("New Motto Recruit Available")]), _c('BaseIcon', {
    staticClass: "color-white",
    attrs: {
      "name": "user-plus"
    }
  })], 1), _vm.expirationDate ? _c('p', {
    class: _vm.$style.subHeaderContainer
  }, [_vm._v("You have until "), _c('span', {
    staticClass: "color-secondary-red"
  }, [_vm._v(_vm._s(_vm.expirationDate))]), _vm._v(" to respond, or this recruit will automatically be declined.")]) : _vm._e(), _c('div', {
    class: _vm.$style.infoContainer
  }, [_c('div', [_c('div', {
    class: _vm.$style.infoGroupContainer
  }, [_c('div', {
    class: _vm.$style.infoGroup
  }, [_c('span', [_vm._v("Name:")]), _c('p', [_vm._v(_vm._s(_vm.prospect.name))])]), (_vm$potentialRoles = _vm.potentialRoles) !== null && _vm$potentialRoles !== void 0 && _vm$potentialRoles.length ? _c('div', {
    class: _vm.$style.infoGroup
  }, [_c('span', [_vm._v("Potential Roles:")]), _c('p', [_vm._v(_vm._s(_vm.arrayToSentence(_vm.potentialRoles, ', ', ', ')))])]) : _vm._e()])])]), _c('SimpleDivider'), _vm.prospect.recruiterNote ? _c('p', {
    class: _vm.$style.recruiterNotes
  }, [_vm._v(" Hey " + _vm._s(_vm.currentUser.firstName) + ","), _c('br'), _vm._v(" " + _vm._s(_vm.prospect.recruiterNote) + " ")]) : _vm._e(), _c('div', {
    class: _vm.$style.footer
  }, [_c('div', {
    class: _vm.$style.recruiterInfo
  }, [_c('ProfilePicture', {
    class: _vm.$style.profilePicture,
    attrs: {
      "src": _vm.assignedTo.photoUrl
    }
  }), _c('div', [_c('p', [_vm._v(_vm._s(_vm.assignedTo.name))]), _vm.assignedTo.jobTitle ? _c('p', [_vm._v(_vm._s(_vm.assignedTo.jobTitle))]) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.assignedTo.phone))]), _c('a', {
    attrs: {
      "href": `mailto:${_vm.assignedTo.email}`
    }
  }, [_vm._v(_vm._s(_vm.assignedTo.email))])])], 1), _c('InfoBlock', {
    attrs: {
      "icon-color": "primary"
    }
  }, [_vm._v(" Click “Accept” to begin the MottoCenter account creation process.")]), _c('div', {
    class: _vm.$style.buttons
  }, [_c('BaseButton', {
    attrs: {
      "theme": "white"
    },
    on: {
      "click": _vm.openConfirmDeclineProspect
    }
  }, [_vm._v("Decline")]), _c('BaseButton', {
    attrs: {
      "theme": "blue"
    },
    on: {
      "click": _vm.approveProspect
    }
  }, [_vm._v("Accept")])], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modalConfirmDeclineProspect",
      "modal-class": "confirmation-modal",
      "title": "Decline Prospect",
      "ok-variant": "danger",
      "ok-title": "Yes",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading
    },
    on: {
      "cancel": _vm.openApproveProspect,
      "ok": _vm.openReasonForDeclineProspect
    }
  }, [_vm._v(" Are you sure you want to decline this Prospect? ")]), _c('b-modal', {
    attrs: {
      "id": "modalReasonForDeclineProspect",
      "modal-class": "confirmation-modal",
      "title": "Decline Prospect",
      "ok-variant": "danger",
      "ok-title": "Submit",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading || !_vm.isReasonForDeclineValid
    },
    on: {
      "cancel": _vm.openApproveProspect,
      "ok": _vm.declineProspect
    }
  }, [_vm._v(" Please provide your reason for declining this prospect. Your feedback helps us narrow our search to prospects that align with your business needs. "), _c('FormItem', {
    staticClass: "mt-4 flex-shrink-0",
    attrs: {
      "label": "Reason For Prospect Decline",
      "edit-mode": "",
      "value": _vm.reasonForProspectDecline,
      "edit-select-values": _vm.reasonsForProspectDecline,
      "options": {
        hideLabel: true
      },
      "rules": "required",
      "placeholder": "Select..."
    },
    on: {
      "update:value": function ($event) {
        _vm.reasonForProspectDecline = $event;
      }
    }
  }), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.reasonForProspectDecline === 'Other',
      expression: "reasonForProspectDecline === 'Other'"
    }],
    staticClass: "mt-4",
    attrs: {
      "textarea": "",
      "label": "Other",
      "rules": "max:200|required",
      "character-limit-options": {
        showOnlyError: true
      },
      "value": _vm.reasonForProspectDeclineOther,
      "options": {
        hideLabel: true
      },
      "edit-mode": ""
    },
    on: {
      "update:value": function ($event) {
        _vm.reasonForProspectDeclineOther = $event;
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }